<template>
  <v-card>
    <v-toolbar>
      <v-btn
        class="mr-3"
        title="Back to Standardizer Home"
        @click="$router.push('/stdizer')"
        v-b-tooltip
        aria-label="Back to Standardizer Home"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>

      <v-text-field
        v-if="items && items.length"
        v-model="search"
        append-icon="mdi-magnify"
        hide-details
        label="Search in any field"
        single-line
        style="max-width: 15em"
      />

      <v-spacer />

      <v-switch
        v-if="items && items.length"
        v-model="selectable"
        class="mt-5 mr-4"
        label="Select"
      />

      <v-btn-toggle dense>
        <DeleteDialog
          v-model="visibleDelete"
          :disabled="!selected.length"
          :items="selected"
          :visible="selectable"
          button-title="mdi-delete"
          :api-url="STDIZER_URL"
          object-type="protocols"
          title="Delete selected protocols"
          @click="deleteItems(selected)"
          @itemDeleted="removeItems"
        />
      </v-btn-toggle>
    </v-toolbar>

    <v-data-table
      v-model="selected"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 30, 50, -1],
      }"
      :hide-default-footer="items.length <= 10"
      :headers="headers"
      :items="items"
      :search="search"
      :items-per-page="50"
      :show-select="selectable"
      item-key="id"
    >
      <template #[`item.name`]="{ item }">
        <b-link :to="`/stdizer/protocols/${item.id}`">
          {{ item.name }}
        </b-link>
      </template>

      <template #[`item.workflow`]="{ item }">
        <b-link
          v-if="isAdmin"
          :to="`/stdizer/groups/${item.options.workflow}`"
        >
          {{ item.options.workflow }}
        </b-link>
        <template v-else>
          {{ item.options.workflow }}
        </template>
      </template>

      <template #[`item.recordsNumber`]="{ item }">
        <b-link :to="`/stdizer/protocols/${item.id}`">
          {{ item.recordsNumber }}
        </b-link>
      </template>
      <template #[`item.componentsNumber`]="{ item }">
        <b-link :to="`/stdizer/protocols/${item.id}?components=true`">
          {{ item.componentsNumber }}
        </b-link>
      </template>
      <template #[`item.changedNumber`]="{ item }">
        <b-link :to="`/stdizer/protocols/${item.id}?changed=true`">
          {{ item.changedNumber }}
        </b-link>
      </template>
      <template #[`item.passedNumber`]="{ item }">
        <b-link :to="`/stdizer/protocols/${item.id}?passed=true`">
          {{ item.passedNumber }}
        </b-link>
      </template>
      <template #[`item.failedNumber`]="{ item }">
        <b-link :to="`/stdizer/protocols/${item.id}?failed=true`">
          {{ item.failedNumber }}
        </b-link>
      </template>

      <template #[`item.dateCreated`]="{ item }">
        {{ dateTimeFormat.format(item.dateCreated) }}
      </template>

      <template
        v-if="!selectable"
        #[`item.actions`]="{ item }"
      >
        <v-icon
          title="Delete"
          @click="deleteItems([item])"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { dateFromObjectId, STDIZER_URL } from '@/main'
import DeleteDialog from '../dialogs/DeleteDialog.vue'
import { mapGetters } from 'vuex'

export default {
  components: { DeleteDialog },

  data: () => ({
    dateTimeFormat: new Intl.DateTimeFormat('en-US', {
      dateStyle: 'short',
      timeStyle: 'short',
    }),
    search: null,
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Workflow', value: 'workflow' },
      { text: 'Status', value: 'status' },
      { text: 'Records #', value: 'recordsNumber', filterable: false },
      { text: 'Components #', value: 'componentsNumber', filterable: false },
      { text: 'Changed #', value: 'changedNumber', filterable: false },
      { text: 'Passed #', value: 'passedNumber', filterable: false },
      { text: 'Failed #', value: 'failedNumber', filterable: false },
      { text: 'Comments', value: 'comment' },
      {
        text: 'Date Created',
        value: 'dateCreated',
        sortable: false,
        filterable: false,
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        filterable: false,
        align: 'end',
      },
    ],
    items: [],
    visibleDelete: false,
    selected: [],
    selectable: false,
  }),

  computed: {
    ...mapGetters(['isAdmin']),
    STDIZER_URL() {
      return STDIZER_URL
    },
  },

  methods: {
    deleteItems(items) {
      this.selected = items
      this.visibleDelete = true
    },
    removeItems(items) {
      if (!Array.isArray(items)) this.items.splice(this.items.indexOf(items), 1)
      else items.forEach((item) => this.items.splice(this.items.indexOf(item), 1))
    },
    getData() {
      this.$axios.get(`${STDIZER_URL}/protocols`).then((response) => {
        response.data.forEach((s) => (s.dateCreated = dateFromObjectId(s.id)))
        this.items = response.data
      })
    },
  },

  mounted() {
    this.getData()
  },
}
</script>

<style scoped></style>
